import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./index.css";
import { addWallet, getWalletData } from "../../services/AuthServices";
import { toast } from "react-toastify";
import Loader from "../../containers/Loader";
import _ from "lodash";
import img from "../../assets/images/dream-prize.jpeg";
import PaymentPopup from "./PaymentPopup";

const MainSection = () => {
  const [isLoading, setisLoading] = useState(false);
  const [data, setdata] = useState({});
  const [page, setpage] = useState(1);
  const [newTransaction, setNewTransaction] = useState("");
  const [showPaymentModal, setshowPaymentModal] = useState(false);
  const [transactionInProgress, settransactionInProgress] = useState(false);

  useEffect(() => {
    getData();
  }, [page]);

  const getData = async (updateWalletMsg) => {
    !updateWalletMsg && setisLoading(true);
    await getWalletData(page)
      .then((response) => {
        let res = response?.data?.data;
        setdata(res);
        if (updateWalletMsg) {
          settransactionInProgress(false);
          setshowPaymentModal(false);
          setNewTransaction("");
          toast(updateWalletMsg, { type: "success" });
        }
        !updateWalletMsg && setisLoading(false);
      })
      .catch((error) => {
        !updateWalletMsg && setisLoading(false);
        toast("Something went wrong", { type: "error" });
      });
  };

  const getTransionData = async (paymentKey) => {
    settransactionInProgress(true);
    let formdata = new FormData();
    formdata.append("payment_id", paymentKey);
    formdata.append("amount", newTransaction);
    await addWallet(formdata)
      .then((response) => {
        getData("Coins added successfully!");
      })
      .catch((error) => {
        settransactionInProgress(false);
        toast("Something went wrong", { type: "error" });
      });
  };

  const handlePayment = async () => {
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: newTransaction * 100,
      currency: "INR",
      name: "Dream Prize",
      description: `Purchase ${newTransaction} Coins`,
      image: img,
      handler: function (response) {
        settransactionInProgress(true);
        setshowPaymentModal(true);
        getTransionData(response?.razorpay_payment_id);
      },
      prefill: {
        name: data?.user?.full_name,
        email: data?.user?.email,
        contact: data?.user?.phone_number || "9999999999",
      },
      theme: {
        color: "#7000ff",
      },
    };

    const razor = new window.Razorpay(options);
    razor.open();
  };

  const handlePageClick = (url) => {
    if (url) {
      const pageNum = new URL(url).searchParams.get("page");
      setpage(pageNum);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="wallet-page">
      <div className="wallet-container">
        {/* Header */}
        <motion.div
          className="wallet-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="wallet-header-content">
            <h1>
              <i className="fas fa-wallet"></i> My Wallet
            </h1>
            <p>Manage your coins and transactions</p>
          </div>
        </motion.div>

        {!isLoading ? (
          <>
            {/* Balance Card */}
            <motion.div
              className="balance-card"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <div className="balance-card-bg"></div>
              <div className="balance-card-content">
                <div className="balance-icon">
                  <i className="fas fa-coins"></i>
                </div>
                <div className="balance-info">
                  <span className="balance-label">Available Balance</span>
                  <h2 className="balance-amount">
                    <span className="coin-icon">🪙</span>
                    {data?.wallet?.balance || 0} Coins
                  </h2>
                  <span className="balance-equivalent">
                    ≈ ₹{data?.wallet?.balance || 0} INR
                  </span>
                </div>
              </div>
              <div className="balance-card-footer">
                <div className="validity-info">
                  <i className="fas fa-info-circle"></i>
                  <span>Coin validity: 1 year from purchase date</span>
                </div>
              </div>
            </motion.div>

            {/* Conversion Info */}
            <motion.div
              className="conversion-card"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <div className="conversion-item">
                <div className="conversion-icon rupee">
                  <i className="fas fa-rupee-sign"></i>
                </div>
                <span className="conversion-value">1</span>
                <span className="conversion-label">Rupee</span>
              </div>
              <div className="conversion-equals">
                <i className="fas fa-exchange-alt"></i>
              </div>
              <div className="conversion-item">
                <div className="conversion-icon coin">
                  <i className="fas fa-coins"></i>
                </div>
                <span className="conversion-value">1</span>
                <span className="conversion-label">Coin</span>
              </div>
            </motion.div>

            {/* Add Coins Section */}
            <motion.div
              className="add-coins-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <div className="add-coins-header">
                <h3>
                  <i className="fas fa-plus-circle"></i> Add Coins
                </h3>
                <p>Purchase coins to participate in draws and buy products</p>
              </div>

              <div className="quick-amounts">
                {[100, 500, 1000, 2000].map((amount) => (
                  <button
                    key={amount}
                    className={`quick-amount-btn ${newTransaction === amount ? 'active' : ''}`}
                    onClick={() => setNewTransaction(amount)}
                    disabled={transactionInProgress}
                  >
                    <span className="quick-amount-coins">🪙 {amount}</span>
                    <span className="quick-amount-price">₹{amount}</span>
                  </button>
                ))}
              </div>

              <div className="custom-amount-section">
                <div className="custom-amount-input-wrapper">
                  <span className="input-prefix">🪙</span>
                  <input
                    type="number"
                    className="custom-amount-input"
                    placeholder="Enter custom amount"
                    disabled={transactionInProgress}
                    value={newTransaction}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "" || Number(val) >= 0) {
                        setNewTransaction(val === "" ? "" : Number(val));
                      }
                    }}
                    min="1"
                  />
                  <span className="input-suffix">Coins</span>
                </div>
                <button
                  className="add-coins-btn"
                  onClick={() => {
                    if (newTransaction && newTransaction > 0) {
                      handlePayment();
                    } else {
                      toast("Please enter a valid amount", { type: "error" });
                    }
                  }}
                  disabled={transactionInProgress || !newTransaction}
                >
                  {transactionInProgress ? (
                    <>
                      <i className="fas fa-spinner fa-spin"></i> Processing...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-credit-card"></i> Pay ₹{newTransaction || 0}
                    </>
                  )}
                </button>
              </div>

              <div className="coins-note">
                <i className="fas fa-shield-alt"></i>
                <span>Secure payment powered by Razorpay. Your coins will be credited instantly.</span>
              </div>
            </motion.div>

            {/* Important Information */}
            <motion.div
              className="info-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.35 }}
            >
              <h4><i className="fas fa-lightbulb"></i> Important Information</h4>
              <ul className="info-list">
                <li>
                  <i className="fas fa-check-circle"></i>
                  <span><strong>1 Rupee = 1 Coin</strong> - Simple and transparent conversion</span>
                </li>
                <li>
                  <i className="fas fa-clock"></i>
                  <span><strong>Validity Period:</strong> Coins are valid for 1 year from the date of purchase</span>
                </li>
                <li>
                  <i className="fas fa-gift"></i>
                  <span>Use coins to participate in lucky draws and win exciting prizes</span>
                </li>
                <li>
                  <i className="fas fa-shopping-cart"></i>
                  <span>Coins can also be used to purchase products from our store</span>
                </li>
                <li>
                  <i className="fas fa-ban"></i>
                  <span>Coins are non-refundable and cannot be transferred to another account</span>
                </li>
              </ul>
            </motion.div>

            {/* Transaction History */}
            <motion.div
              className="transactions-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <div className="transactions-header">
                <h3>
                  <i className="fas fa-history"></i> Transaction History
                </h3>
              </div>

              {!_.isEmpty(data?.transactions?.data) ? (
                <>
                  <div className="transactions-list">
                    {data?.transactions?.data?.map((transaction) => (
                      <motion.div
                        className={`transaction-item ${transaction?.type === "dr" ? "debit" : "credit"}`}
                        key={transaction?.id}
                        initial={{ x: -20, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="transaction-icon">
                          {transaction?.type === "dr" ? (
                            <i className="fas fa-arrow-up"></i>
                          ) : (
                            <i className="fas fa-arrow-down"></i>
                          )}
                        </div>
                        <div className="transaction-details">
                          <span className="transaction-type">
                            {transaction?.type === "dr" ? "Coins Used" : "Coins Added"}
                          </span>
                          <span className="transaction-date">
                            {formatDate(transaction?.created_at)}
                          </span>
                        </div>
                        <div className="transaction-amount">
                          <span className={transaction?.type === "dr" ? "debit" : "credit"}>
                            {transaction?.type === "dr" ? "-" : "+"}
                            {transaction?.amount} 🪙
                          </span>
                        </div>
                      </motion.div>
                    ))}
                  </div>

                  {/* Pagination */}
                  {data?.transactions?.links && data?.transactions?.links.length > 3 && (
                    <div className="pagination-wrapper">
                      {data?.transactions?.links.map((link, index) => (
                        <button
                          key={index}
                          className={`pagination-btn ${link.active ? "active" : ""} ${!link.url ? "disabled" : ""}`}
                          onClick={() => handlePageClick(link.url)}
                          disabled={!link.url}
                          dangerouslySetInnerHTML={{ __html: link.label }}
                        />
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <div className="empty-transactions">
                  <div className="empty-icon">
                    <i className="far fa-receipt"></i>
                  </div>
                  <h4>No Transactions Yet</h4>
                  <p>Your transaction history will appear here once you add coins.</p>
                </div>
              )}
            </motion.div>
          </>
        ) : (
          <div className="loading-wrapper">
            <Loader />
          </div>
        )}

        {showPaymentModal && (
          <PaymentPopup
            setShowModal={setshowPaymentModal}
            showModal={showPaymentModal}
            transactionInProgress={transactionInProgress}
          />
        )}
      </div>
    </div>
  );
};

export default MainSection;
